import { ReactNode } from 'react';

import { ModalWidth, ShowModalEventInterceptor } from '@dreryk/react-components';

import { entitlementStatementsTranslationKeys } from '../../../translations';

import { ConfirmationModalContent } from './ConfirmationModalContent';

type DatesShowModalEventInterceptorProps = {
   readonly differentDates: boolean;
   readonly children: ReactNode;
};

export const DatesShowModalEventInterceptor = (props: DatesShowModalEventInterceptorProps): JSX.Element => {
   return (
      <ShowModalEventInterceptor
         testId='confirmDifferentDatesDates'
         title={entitlementStatementsTranslationKeys.confirmationModal.title}
         confirmationButtonLabel={entitlementStatementsTranslationKeys.confirmationModal.confirmLabel}
         content={<ConfirmationModalContent />}
         modalWidth={ModalWidth.NORMAL}
         shouldShowModal={props.differentDates}
      >
         {props.children}
      </ShowModalEventInterceptor>
   );
};
